import { Box, Container } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { Footer } from './footer';
import { Header } from './header';

const FormsLayout: FC<PropsWithChildren> = ({ children }) => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <Header />
    <Container disableGutters sx={{ maxWidth: { md: '1152px' }, margin: '0 auto', flex: 1 }}>
      {children}
    </Container>
    <Footer />
  </Box>
);

export { FormsLayout };
